var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_27639)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_157_27639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C6.62344 0 7.125 0.501562 7.125 1.125V3H13.875V1.125C13.875 0.501562 14.3766 0 15 0C15.6234 0 16.125 0.501562 16.125 1.125V3H18C19.6547 3 21 4.34531 21 6V6.75V9V21C21 22.6547 19.6547 24 18 24H3C1.34531 24 0 22.6547 0 21V9V6.75V6C0 4.34531 1.34531 3 3 3H4.875V1.125C4.875 0.501562 5.37656 0 6 0ZM18.75 9H2.25V21C2.25 21.4125 2.5875 21.75 3 21.75H18C18.4125 21.75 18.75 21.4125 18.75 21V9ZM15.4219 13.9219L10.1719 19.1719C9.73125 19.6125 9.01875 19.6125 8.58281 19.1719L5.58281 16.1719C5.14219 15.7312 5.14219 15.0188 5.58281 14.5828C6.02344 14.1469 6.73594 14.1422 7.17188 14.5828L9.375 16.7859L13.8281 12.3328C14.2688 11.8922 14.9812 11.8922 15.4172 12.3328C15.8531 12.7734 15.8578 13.4859 15.4172 13.9219H15.4219Z",
    fill: "#00C875"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_27639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_157_27639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledIcon);
export default __webpack_public_path__ + "static/media/Scheduled_icon.691b2ce4817f89ebb466c2ed926334d4.svg";
export { ForwardRef as ReactComponent };